import Vue from 'vue';

/**
 * When the request succeeds
 */
const success = (response, resolve) => {
  resolve();
};

/**
 * When the request fails
 */
const failed = (error, reject) => reject(error.response.data);

export default userId => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/auth/${userId}/resend_sms_2fa_code`)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/auth/resendSmsTwoFactorCode.js